import type IMapProperty from './IMapProperty';
import type { ObjectType } from './interface';

function mapToInternalProps<IntProps extends ObjectType, ExtProps extends ObjectType>(
    mappings: IMapProperty[],
    sourceObject?: Partial<ExtProps>,
): IntProps {
    const props: Record<string, unknown> = {};

    for (const property of mappings) {
        let newValue = null;
        const externalName = (property.externalName ?? property.localName) as keyof ExtProps;
        const saveKey = property.localName;

        if (!saveKey) {
            /* Ignore */
        } else if (!sourceObject) {
            /* Ignore */
        } else if (property.removeValueOnImport ?? false) {
            /* Ignore */
        } else if (property.customImport) {
            newValue = property.customImport(sourceObject);
        } else if (sourceObject[externalName] !== undefined) {
            newValue = sourceObject[externalName] as typeof property.defaultValue;
        } else if (property.defaultValue !== null && property.defaultValue !== undefined) {
            newValue = property.defaultValue;
        }

        if (saveKey && newValue !== null && newValue !== undefined) {
            props[saveKey] = newValue;
        }
    }

    return props as IntProps;
}

function mapToExternalProps<IntProps extends ObjectType, ExtProps extends ObjectType>(
    mappings: IMapProperty[],
    sourceObject?: Partial<IntProps>,
): ExtProps {
    const props: Record<string, unknown> = {};

    for (const property of mappings) {
        let newValue = null;
        const saveKey = (property.localName ?? property.externalName) as keyof IntProps;

        if (!saveKey) {
            /* Ignore */
        } else if (!sourceObject) {
            /* Ignore */
        } else if (property.removeValueOnExport ?? false) {
            /* Ignore */
        } else if (property.customExport) {
            newValue = property.customExport(sourceObject);
        } else if (sourceObject[saveKey] !== undefined) {
            newValue = sourceObject[saveKey] as typeof property.defaultValue;
        } else if (property.defaultValue !== null && property.defaultValue !== undefined) {
            newValue = property.defaultValue;
        }

        if (saveKey && newValue !== null && newValue !== undefined) {
            props[saveKey as string] = newValue;
        }
    }

    return props as ExtProps;
}

export default Object.freeze({
    mapToExternalProps,
    mapToInternalProps,
});
